<template>
  <div id="LCStudies">
    <div id="LCStudies-top"></div>
    <div id="LCStudies-body">
      <p class="constituent-part-title">三个组成部分</p>
      <p class="constituent-part-title-content">大型列队人群研究一站式体验</p>
      <div class="constituent-part-content">
        <div class="constituent-part-content-left">
          <img src="../../assets/images/Solution/LCStudies/left.png"/>
          <p>灵活定制<br>时时增加 / 修改 / 删除量表<br>为队列的研究提供可靠工具</p>
        </div>
        <div class="constituent-part-content-middle">
          <img src="../../assets/images/Solution/LCStudies/middle.png"/>
          <p>构建和用户的沟通渠道<br>能提高患者的配合程度<br>减少失访率。</p>
        </div>
        <div class="constituent-part-content-right">
          <img src="../../assets/images/Solution/LCStudies/right.png"/>
          <p>自定义随访点及量表评测工作<br>自定义消息内容及推送时间<br>提供一站式的后台管理系统</p>
        </div>
      </div>
      <p class="LCStudies-successful-case-title">成功案例</p>
      <p class="LCStudies-successful-case-content">（国家儿童中心上海儿童医学中心：早期儿童健康促进项目）</p>
      <div class="LCStudies-successful-case-div">
        <img src="../../assets/images/Solution/LCStudies/ProjectWechatQRCode.png"/>
        <p>在国家科技部重点专项，卫生部和国家自然基金的大力支持下，上海儿童医学中心和仁济医院合作推出“婴幼儿健康促进项目”，目的是优化生育质量,促进宝宝健康成长。在2012年08月至2013年08月招募了277对母婴成功进行了两年的母婴健康监测和评价，免费提供孕期保健和育儿指导，并为参与家庭特设门诊绿色通道。项目取得巨大成功,深受家长喜爱，成为家长最佳帮手。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
#LCStudies-top{
  height: 600px;
  background-size: auto 100%;
  background-position:center;
  background-repeat: no-repeat;
  background-image: url(../../assets/images/Solution/LCStudies/LCStudies_Banner.png);
}
#LCStudies-body{
  padding-top: 60px;
  padding-bottom: 60px;
}
#LCStudies-body .constituent-part-title{
  font-size: 36px;
  color: #282828;
}
#LCStudies-body .constituent-part-title-content{
  font-size: 18px;
  margin-top: 4px;
  color: #909090;
}
#LCStudies-body .constituent-part-content{
  font-size: 16px;
  color: #404040;
  margin-top: 38px;
}
#LCStudies-body .constituent-part-content .constituent-part-content-left{
  display: inline-block;
  margin-right: 72px;
}
#LCStudies-body .constituent-part-content .constituent-part-content-middle{
  display: inline-block;
  margin-right: 60px;
}
#LCStudies-body .constituent-part-content .constituent-part-content-right{
  display: inline-block;
}
#LCStudies-body .constituent-part-content p{
  line-height: 22px;
}
#LCStudies-body .constituent-part-content .constituent-part-content-left p{
  margin-top: 22px;
}
#LCStudies-body .constituent-part-content .constituent-part-content-middle p{
  margin-top: 26px;
}
#LCStudies-body .constituent-part-content .constituent-part-content-right p{
  margin-top: 28px;
}
#LCStudies-body .LCStudies-successful-case-title{
  font-size: 18px;
  color: #404040;
  margin-top: 40px;
}
#LCStudies-body .LCStudies-successful-case-content{
  font-size: 16px;
  margin-top: 4px;
  color: #909090;
}
#LCStudies-body .LCStudies-successful-case-div{
  width:1080px;
  padding-top: 20px;
  margin: 0 auto;
}
#LCStudies-body .LCStudies-successful-case-div img{
  display: inline-block;
}
#LCStudies-body .LCStudies-successful-case-div p{
  width: 438px;
  color: #282828;
  text-indent: 2em;
  margin-left: 19px;
  font-size: 14px;
  line-height: 24px;
  text-align: left;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/Solution/LCStudies.vue